import useAppModernisation from "../../hooks/useAppModernisation";
import GuidelineNav from "../../components/GuidelineNav/GuidelineNav";
import GuidelineNavWeb from "../../components/GuidelineNav/GuidelineNavWeb";
import useScreenSize from "../../hooks/useScreenSize";
import GuidelineNavApp from "../../components/GuidelineNav/GuidelineNavApp";

const GuidelineNavRouter = ({guidelineObj}) => {
  const { isAppMode, isWebModernisationEnabled } = useAppModernisation();
  const { isDesktop } = useScreenSize();

  if (isAppMode) {
    return isWebModernisationEnabled ? (
      <GuidelineNavApp glObj={guidelineObj} />
    ) : (
      <GuidelineNav glObj={guidelineObj} />
    );
  }

  if (!isDesktop) {
    return <GuidelineNavApp glObj={guidelineObj} />;
  }

  if (isWebModernisationEnabled) {
    return <GuidelineNavWeb glObj={guidelineObj} />;
  }

  return <GuidelineNav glObj={guidelineObj} />;
};

export default GuidelineNavRouter;